/* ============================================================
   Header — kleiner Fortschrittsbalken neben dem Warenkorb-Symbol.

   Zeigt dieselben zwei Schwellen wie der Reisbalken im Warenkorb, nur auf wenigen
   Pixeln: rot bis zum Mindestbestellwert, gelb bis zum versandkostenfreien Betrag,
   grün und voll darüber. Der Satz daneben ist derselbe wie im Warenkorb — er kommt aus
   assets/cart-hinweis.js, damit beide Stellen nicht auseinanderlaufen.

   Die Skala reicht wie im Warenkorb von 0 bis zum Versandkostenfrei-Betrag. Der Balken
   ist also auch dann noch nicht voll, wenn der Mindestbestellwert schon erreicht ist —
   das ist genau die Aussage: bestellbar ja, versandkostenfrei noch nicht.

   Die Beträge stehen NICHT hier, sondern kommen als data-Attribute aus
   snippets/cart-schwellen.liquid.
   ============================================================ */
(function () {
  'use strict';

  // Rückfallebene, falls cart-hinweis.js einmal nicht geladen ist. Bewusst wortgleich
  // mit dem Original — hier soll nichts Zweites entstehen, das anders klingt.
  var HINWEIS = window.cartHinweis || {
    euro: function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; },
    betrag: function (c) { return '€' + (c / 100).toFixed(2).replace('.', ','); },
    text: function (total, min, free, max) {
      if (max && total >= max) return 'Maximaler Bestellwert erreicht';
      if (total < min) return 'Noch ' + this.euro(min - total) + ' bis zum Mindestbestellwert';
      if (total < free) return 'Noch ' + this.euro(free - total) + ' bis versandkostenfrei';
      return 'Versandkostenfrei erreicht';
    },
    stufe: function (total, min, free, max) {
      if (max && total >= max) return 'max';
      if (total < min) return 'min';
      if (total < free) return 'versand';
      return 'frei';
    },
    skala: function (free, max) { return max && max > 0 ? max : free; }
  };

  /* Kurzes gelbes Aufblinken am Warenkorbbereich des Kopfbereichs.

     DAUER: 500 ms, danach nimmt der Zeitgeber die Klasse wieder weg. Das Gelb erscheint
     ohne Uebergang und blendet erst beim Abraeumen aus (siehe base.css, --hcf-tempo);
     dessen 0,1s kommen zu diesen 500 ms hinzu.

     Der Zeitgeber liegt bewusst ausserhalb der Funktion: Wer zweimal schnell hintereinander
     etwas hineinlegt, soll die vollen 500 ms ab dem ZWEITEN Mal sehen. Ohne das Loeschen
     des vorigen Zeitgebers wuerde der erste dazwischenfunken und zu frueh abraeumen. */
  var blinkTimer = null;
  function blinken(zone) {
    window.clearTimeout(blinkTimer);
    zone.classList.add('is-cart-flash');
    blinkTimer = window.setTimeout(function () {
      zone.classList.remove('is-cart-flash');
    }, 500);
  }

  function init(root) {
    var fill = root.querySelector('[data-hcb-fill]');
    // Hinweissatz und Bestellwert stehen als Geschwister NEBEN dem Balken (zwischen ihm
    // und dem Warenkorb-Symbol), deshalb ueber das Dokument gesucht und nicht ueber root.
    var textEl = document.querySelector('[data-hcb-text]');
    var betragEl = document.querySelector('[data-hct-value]');
    var totalBox = document.querySelector('[data-header-cart-total]');
    var zone = document.querySelector('.header__icons');

    var MIN = parseInt(root.dataset.min, 10) || 0;
    var FREE = parseInt(root.dataset.free, 10) || 0;
    // Hoechstbestellwert. 0 heisst: keiner — nur die Schweiz hat einen.
    var MAX = parseInt(root.dataset.max, 10) || 0;
    // Bezugsgroesse des Balkens: bis zur Obergrenze, sonst bis versandkostenfrei.
    var SKALA = HINWEIS.skala ? HINWEIS.skala(FREE, MAX) : FREE;

    function render(total) {
      // Leerer Warenkorb: Der Balken verschwindet, statt auf jeder Seite den vollen
      // Mindestbestellwert anzumahnen. Er wird nur ausgeblendet und nicht entfernt,
      // damit er beim ersten hineingelegten Artikel ohne Neuladen wieder auftaucht.
      root.classList.toggle('is-empty', total <= 0);

      root.dataset.stufe = HINWEIS.stufe(total, MIN, FREE, MAX);

      var anteil = SKALA > 0 ? Math.min(1, total / SKALA) : 0;
      if (fill) fill.style.width = (anteil * 100) + '%';
      if (textEl) textEl.textContent = HINWEIS.text(total, MIN, FREE, MAX);

      // Bestellwert daneben. Bewusst hier und nicht in einem eigenen Skript: Diese Stelle
      // kennt den neuen Betrag bereits und laeuft bei jeder Warenkorbaenderung.
      if (betragEl) {
        // Nur die Summe, ohne Beschriftung davor — was sie bedeutet, sagt bereits das
        // Warenkorb-Symbol unmittelbar daneben.
        // betrag() statt euro(): Schreibweise wie die Summe im Warenkorb (€21,99).
        betragEl.textContent = HINWEIS.betrag ? HINWEIS.betrag(total) : HINWEIS.euro(total);
      }
      if (totalBox) {
        totalBox.classList.toggle('is-empty', total <= 0);
        // Dieselbe Stufe auch am Textblock: Balken und Satz sind seit der Umstellung
        // Geschwister, das CSS des Satzes kommt sonst nicht mehr an die Stufe heran.
        totalBox.dataset.stufe = HINWEIS.stufe(total, MIN, FREE, MAX);
      }
    }

    function refreshFromCart() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart.total_price); })
        .catch(function () { /* Netzfehler: der zuletzt gezeigte Stand bleibt stehen */ });
    }

    // Erster Aufbau aus dem serverseitig gerenderten Wert, ohne Wartezeit auf /cart.js.
    render(parseInt(root.dataset.total, 10) || 0);

    // Aktualisierung über Dawns Ereignisbus. Der Header wird bei einer Warenkorbänderung
    // NICHT neu vom Server geholt — Dawn tauscht nur den Zähler am Symbol aus (Sektion
    // cart-icon-bubble). Dieser Balken steht außerhalb davon und muss sich deshalb selbst
    // nachführen. Die Meldung enthält den neuen Warenkorb meist schon; wenn nicht (etwa
    // beim Hinzufügen von einer Produktseite), wird er einmal nachgeladen.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var data = event && event.cartData;
        if (data && typeof data.total_price === 'number') render(data.total_price);
        else refreshFromCart();

        // Kurzes gelbes Aufblinken bei JEDER Aenderung am Warenkorb: Der Bestellwert
        // bekommt einen gelben Kasten, die Zahl am Warenkorb-Symbol wird gelb mit roter
        // Ziffer. Ausgeloest vom Kaufen-Knopf ('product-form'), vom Schnellkauf
        // ('quick-add') UND von Mengenaenderungen oder Loeschen im Warenkorb selbst
        // ('cart-items') -- auch dort aendert sich der Bestellwert, und genau darauf soll
        // der Blick fallen.
        //
        // Die Quellen stehen einzeln da statt eines pauschalen "immer": So loest eine
        // kuenftige Meldung anderer Herkunft nicht ungewollt ein Aufblinken aus.
        //
        // Gesteuert ueber eine Klasse mit Zeitgeber und NICHT ueber eine CSS-Animation:
        // Die Ziffer in der Blase wird an anderer Stelle mit !important beige gefaerbt,
        // und !important schlaegt laut Kaskade jede Animation. Eine Klasse dagegen kann
        // mit hoeherer Spezifitaet und ebenfalls !important dagegenhalten.
        var blinkQuellen = ['product-form', 'quick-add', 'cart-items'];
        if (zone && event && blinkQuellen.indexOf(event.source) > -1) blinken(zone);
      });
    } else {
      // Rückfallebene, falls pubsub.js einmal nicht geladen ist.
      document.addEventListener('change', function (e) {
        if (e.target.closest('cart-items, cart-drawer-items')) setTimeout(refreshFromCart, 600);
      });
      document.addEventListener('click', function (e) {
        if (e.target.closest('cart-remove-button, .quantity__button')) setTimeout(refreshFromCart, 600);
      });
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-header-cart-bar]'), init);

    // Warnfarbe nach dem Ausklingen abraeumen, damit die naechste Warnung wieder von
    // vorn beginnt. Ausgeloest wird sie von assets/cart-max-guard.js.
    Array.prototype.forEach.call(document.querySelectorAll('[data-header-cart-bar]'), function (bar) {
      bar.addEventListener('animationend', function (event) {
        if (event.animationName === 'hcb-max-warnung') bar.classList.remove('is-max-warnung');
      });
    });

    // Frueher stand hier ein Aufraeum-Verarbeiter fuer die Leucht-Animation. Den braucht
    // es nicht mehr: blinken() raeumt seine Klasse selbst per Zeitgeber ab.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
